export async function suspendVideoForBackground({
  callActive = false,
  cameraEnabled = false,
  videoTrack = null
} = {}) {
  if (!callActive || !cameraEnabled || !videoTrack) return false;
  await videoTrack.setEnabled(false);
  return true;
}

export async function restoreVideoAfterBackground({
  callActive = false,
  cameraEnabled = false,
  pageWasBackgrounded = false,
  videoTrack = null
} = {}) {
  if (
    !callActive ||
    !cameraEnabled ||
    !pageWasBackgrounded ||
    !videoTrack
  ) {
    return false;
  }
  // A deliberate off → on transition makes the SDK notify the remote side
  // with unpublished/published events after the mobile OS interrupted capture.
  await videoTrack.setEnabled(false);
  await videoTrack.setEnabled(true);
  return true;
}
